export default __webpack_public_path__ + "5e6cbbd3a8de8f77d7e4bb3aa4fe5c19.jpg";